import { get } from "@/services/api.services";
import {
    ExperimentRelationshipDTO,
    ExperimentRelationshipsForType,
} from "@/services/experimentRelationships/models";

export const experimentRelationshipsAPI = {
    fetchForExperimentCode: async (
        experimentCode: string
    ): Promise<ExperimentRelationshipsForType<ExperimentRelationshipDTO>[]> => {
        return get(`/experimentRelationships/${experimentCode}`);
    },
};
